import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = () => {
  return (
    // The scroll box takes its height from the sidebar's flex column (see
    // layout/sidebar/_sidebar.scss), not from Metronic's ScrollComponent: that
    // measured a pixel height once at load, and whenever it was off the box ran
    // past the window while this clipped it, so the last Settings entries could
    // not be reached.
    <div className='app-sidebar-menu overflow-hidden'>
      <div id='kt_app_sidebar_menu_wrapper' className='app-sidebar-wrapper hover-scroll-overlay-y my-5'>
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
